import { render } from "./Programma.vue?vue&type=template&id=966dcf5c&scoped=true"
import script from "./Programma.vue?vue&type=script&lang=js"
export * from "./Programma.vue?vue&type=script&lang=js"

import "./Programma.vue?vue&type=style&index=0&id=966dcf5c&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-966dcf5c"]])

export default __exports__